import React from "react";
import { Helmet } from "react-helmet";

import TreatmentCards from "../../components/TreatmentCards/TreatmentCards";
import Testimonials from "../../components/Testimonials/Testimonials";
import BlogSection from "../../components/BlogSection/BlogSection";

import doctorImage from "../../assets/images/doctor.png"; // ← save uploaded photo here
import qrImage from "../../assets/images/Google_Link.png";

const Home = () => {

  const phoneNumber = "9340214828";

  const whatsappLink =
    "https://wa.me/919340214828";

  const reviewLink =
    "https://g.page/r/CbI31gOBn4tcEBM/review";

  return (
    <div>

      {/* SEO META */}
      <Helmet>

        <title>
          Best Urologist in Rewa | Dr Abhinav Singh
        </title>

        <meta
          name="description"
          content="Dr Abhinav Singh is a leading urologist in Rewa specializing in kidney stone treatment, prostate enlargement, urinary infections and laparoscopic surgeries."
        />

        <meta
          name="keywords"
          content="best urologist in Rewa, kidney stone doctor Rewa, prostate treatment Rewa, urologist Rewa MP"
        />

      </Helmet>

      {/* HERO SECTION */}
      <section className="py-5">

        <div className="container">

          <div className="row align-items-center">

            {/* LEFT */}
            <div className="col-md-6 text-md-start text-center">

              <h1 className="fw-bold display-5">

                Best Urologist in Rewa  
                <span className="text-primary">
                  {" "}Dr. Abhinav Singh
                </span>

              </h1>

              <p className="lead mt-3">

                Assistant Professor, Department of Urology  
                Super Speciality Hospital &  
                Shyam Shah Medical College, Rewa.

              </p>

              <p>

                Expert in Kidney Stone Treatment,
                Prostate Enlargement (BPH),
                Urinary Tract Infections,
                Male Infertility,
                Urological Cancers,
                and Laparoscopic Surgeries.

              </p>

              {/* BUTTONS */}
             {/*  <div className="mt-4">

                <a
                  href={`tel:${phoneNumber}`}
                  className="btn btn-primary me-3"
                >
                  📞 Call Now
                </a>

                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-success"
                >
                  WhatsApp
                </a>

              </div> */}

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-md-6 text-center mt-4 mt-md-0">

              <img
                src={doctorImage}
                alt="Dr Abhinav Singh Urologist Rewa"
                className="img-fluid rounded shadow"
                style={{
                  maxHeight: "450px"
                }}
              />

            </div>

          </div>

        </div>

      </section>

      {/* QUICK STATS */}
      <section className="py-5 bg-light text-center">

        <div className="container">

          <div className="row">

            <div className="col-md-3">

              <h2 className="text-primary fw-bold">
                3+
              </h2>

              <p>Years Experience</p>

            </div>

            <div className="col-md-3">

              <h2 className="text-primary fw-bold">
                1000+
              </h2>

              <p>Patients Treated</p>

            </div>

            <div className="col-md-3">

              <h2 className="text-primary fw-bold">
                Advanced
              </h2>

              <p>Urology Treatments</p>

            </div>

            <div className="col-md-3">

              <h2 className="text-primary fw-bold">
                Trusted
              </h2>

              <p>Patient Care</p>

            </div>

          </div>

        </div>

      </section>

      {/* SERVICES */}
      <section className="py-5">
        <TreatmentCards />
      </section>

      {/* ABOUT DOCTOR */}
      <section className="py-5 bg-light">

        <div className="container">

          <h2 className="text-center fw-bold mb-4">

            About Dr Abhinav Singh

          </h2>

          <p className="text-center">

            Dr Abhinav Singh is currently serving as
            Assistant Professor in the Department of
            Urology at Super Speciality Hospital and
            Shyam Shah Medical College, Rewa.

            He specializes in kidney stone treatment,
            prostate enlargement (BPH),
            urinary tract infections (UTI),
            male infertility,
            urological cancers,
            and laparoscopic surgeries.

          </p>

        </div>

      </section>

      {/* TESTIMONIALS */}
      <section className="py-5">
        <Testimonials />
      </section>

      {/* BLOG */}
      <section className="py-5 bg-light">
        <BlogSection />
      </section>

      {/* GOOGLE REVIEW */}
      <section className="py-5 text-center">

        <div className="container">

          <h2 className="fw-bold">

            Share Your Experience

          </h2>

          <p className="text-muted">

            Scan QR Code to Leave Google Review

          </p>

          <img
            src={qrImage}
            alt="Google Review QR Code"
            width="150"
            className="shadow rounded mt-3"
          />

          <div className="mt-3">

            <a
              href={reviewLink}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              Write Google Review
            </a>

          </div>

        </div>

      </section>

      {/* ADDRESS */}
      {/* <section className="py-5 bg-light text-center">

        <div className="container">

          <h2 className="fw-bold mb-3">

            Consultation Address

          </h2>

          <p>

            House No E3, Old Doctor's Colony  
            Rewa, Madhya Pradesh 486001

          </p>

          <a
            href="https://www.google.com/maps/place/Dr.+Abhinav+Singh+-+Urologist/@24.5317643,81.29976,17z/data=!3m1!4b1!4m6!3m5!1s0x39845bf3e91fcbb5:0x5c8b9f8103d637b2!8m2!3d24.5317643!4d81.29976!16s%2Fg%2F11z65p0j97?hl=en&entry=ttu&g_ep=EgoyMDI2MDQyMS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noreferrer"
            className="btn btn-outline-primary mt-3"
          >
            View on Google Maps
          </a>

        </div>

      </section> */}

     {/* GOOGLE MAP WITH CLINIC NAME */}
<section className="py-5 bg-light text-center">
  <div className="container">

    {/* <h2 className="fw-bold mb-3">
      Clinic Location
    </h2> */}
      <h2 className="fw-bold mb-3">

            Consultation Address

          </h2>

          <p>

            House No E3, Old Doctor's Colony  
            Rewa, Madhya Pradesh 486001

          </p>

    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.640606510873!2d81.297571!3d24.5317643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39845bf3e91fcbb5%3A0x5c8b9f8103d637b2!2sDr.%20Abhinav%20Singh%20-%20Urologist!5e0!3m2!1sen!2sin!4v1713950000000"
      width="100%"
      height="400"
      style={{ border: 0, borderRadius: "10px" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Dr Abhinav Singh Clinic"
    ></iframe>

  </div>
</section>

      {/* FAQ */}
      <section className="py-5">

        <div className="container">

          <h2 className="text-center fw-bold mb-4">

            Frequently Asked Questions

          </h2>

          <div className="mb-3">

            <h5>
              What diseases does a urologist treat?
            </h5>

            <p>
              Kidney stones, prostate problems,
              urinary infections, male infertility
              and urological cancers.
            </p>

          </div>

          <div className="mb-3">

            <h5>
              When should I visit a urologist?
            </h5>

            <p>
              If you experience pain during urination,
              kidney stone pain, or prostate symptoms.
            </p>

          </div>

        </div>

      </section>

      {/* CLINIC TIMING */}
      <section className="py-5 bg-light text-center">

        <div className="container">

          <h2 className="fw-bold">

            For Consultation Timings

          </h2>

          <p>
            Monday – Saturday
          </p>

          <p>
            05:00 PM – 09:00 PM
          </p>

          <p className="text-muted">
            Sunday – Closed
          </p>

        </div>

      </section>

      {/* CALL BUTTON */}
      {/* <a
        href={`tel:${phoneNumber}`}
        className="btn btn-danger position-fixed"
        style={{
          bottom: "20px",
          right: "20px",
          zIndex: "999"
        }}
      >
        Call Now
      </a> */}

      {/* WHATSAPP BUTTON */}
      {/* <a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        className="btn btn-success position-fixed"
        style={{
          bottom: "80px",
          right: "20px",
          zIndex: "999"
        }}
      >
        WhatsApp
      </a> */}

      {/* SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Physician",
          "name": "Dr Abhinav Singh",
          "medicalSpecialty": "Urology",
          "telephone": "+919340214828",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "House No E3, Old Doctor's Colony",
            "addressLocality": "Rewa",
            "addressRegion": "MP",
            "postalCode": "486001",
            "addressCountry": "India"
          }
        }
        `}
      </script>

    </div>
  );
};

export default Home;